window.ORDER_PAGE_MISC_HELPERS = {
    changeShowHideOperators(shortname) {
        if (this.showHideOperators === shortname) {
            this.showHideOperators = null
            return
        }
        this.showHideOperators = shortname
    },

    showInfoAboutTypeMessage() {
        window.orderPageAlert($L('ords.change_type_description'))
    },

    // EXTERNAL PROVIDER NOTICE: remove this helper if the external-provider note is not needed.
    showExternalProviderInfo() {
        window.orderPageAlert($L('ords.external_provider_notice'))
    },

    showSmsPvaOperatorInfo() {
        window.orderPageAlert(this.getSmsPvaOperatorInfoText())
    },

    showDonorSuccessRateInfo(successRate) {
        window.orderPageAlert(this.getDonorSuccessRateInfoText(successRate))
    },

    getSmsPvaOperatorInfoText() {
        return $L('ords.smspva_operator_notice')
    },

    getDonorSuccessRateInfoText(successRate) {
        return $L('ords.external_provider_success_rate').replace('{RATE}', successRate)
    },

    replaceText(text, replaseObj) {
        if (!text || !replaseObj) {
            return false
        }

        let newText = text

        for (const key in replaseObj) {
            const re = new RegExp(key, 'g')
            newText = newText.replace(re, replaseObj[key])
        }

        return newText
    },

    goTo(link) {
        window.location.href = link
    },

    validateEmail(email) {
        const regex = /^[a-zA-Z0-9.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        return regex.test(email)
    },

    selectCountryInNewService(shortname) {
        if (this.newServiceCountries.indexOf(shortname) === -1) {
            this.newServiceCountries.push(shortname)
        } else {
            this.newServiceCountries.splice(this.newServiceCountries.indexOf(shortname), 1)
        }
    },

    selectAllInAddNewService() {
        if (this.allCountries.length === this.newServiceCountries.length) {
            this.newServiceCountries = []
            return
        }

        this.newServiceCountries = []
        this.allCountries.forEach((country) => {
            this.newServiceCountries.push(country.shortname)
        })
    },

    async sendRequestToAddNewService() {
        this.newServiceNameError = false
        this.newServiceLinkError = false
        if (this.newServiceName === '') {
            this.newServiceNameError = true
        } else if (this.newServiceLink === '') {
            this.newServiceLinkError = true
        } else if (this.newServiceCountries.length < 1) {
            await this.notifyUser($L('ords.notfound_country_by_service'), 'error')
        } else {
            let selectedCountries = ''
            if (this.newServiceCountries.length === this.allCountries.length) {
                selectedCountries = 'ALL'
            } else {
                this.newServiceCountries.forEach((country) => {
                    selectedCountries = selectedCountries + ', ' + country
                })
                selectedCountries = selectedCountries.substring(2)
            }

            let textMeTalkMess = $L('ords.me_talk_add_new_service')
            textMeTalkMess = textMeTalkMess.replace('{serviceName}', this.newServiceName)
            textMeTalkMess = textMeTalkMess.replace('{serviceLink}', this.newServiceLink)
            textMeTalkMess = textMeTalkMess.replace('{countryName}', selectedCountries)

            window.MeTalk('openSupport')
            window.MeTalk('sendMessage', textMeTalkMess)
            this.newServiceModalIsVisible = false
        }
    },

    async sendRequestToVacancy() {
        this.vacancyModalNameError = false
        this.vacancyModalPaymentError = false
        this.vacancyModalInfoError = false
        if (this.vacancyModalName == '') {
            this.vacancyModalNameError = true
        } else if (this.vacancyModalPayment == '') {
            this.vacancyModalPaymentError = true
        } else if (this.vacancyModalContact == '') {
            this.vacancyModalContactError = true
        } else if (this.vacancyModalInfo == '') {
            this.vacancyModalInfoError = true
        } else {
            const data = new FormData()
            data.append('method', 'LEAVE_VACANCY')
            data.append('name', this.vacancyModalName)
            data.append('salary', this.vacancyModalPayment)
            data.append('contacts', this.vacancyModalContact)
            data.append('info', this.vacancyModalInfo)
            axios({
                method: 'post',
                url: '/sms_api/orders.php?n=4-3',
                data: data
            }).catch(function(err) {
                console.log(err)
            })
            this.notifyUser($L('ords.resume_sent'))
            this.vacancyModalIsVisible = false
            this.vacancyModalName = ''
            this.vacancyModalPayment = ''
            this.vacancyModalContact = ''
            this.vacancyModalInfo = ''
        }
    },

    scrollToTop() {
        window.scrollTo(pageYOffset, 0)
    },

    startTimer() {
        const event = new Event('tick')
        const eventActivation = new Event('tickActivation')

        if (!this.stopRequests) {
            window.dispatchEvent(event)
        }

        window.dispatchEvent(eventActivation)
        setTimeout(this.startTimer.bind(this), 1000)
    },

    updateScreenWidth() {
        this.screenWidth = window.innerWidth
        this.mobile = this.screenWidth < 1200

        const favoriteAndTypeBox = document.querySelector('.favorites_and_type_box')

        if (favoriteAndTypeBox) {
            const favorites = favoriteAndTypeBox.querySelector('.favorites_btn')
            const type = favoriteAndTypeBox.querySelector('.type_message')
            if (favorites && type) {
                const elWidth = favorites.offsetWidth + type.offsetWidth
                favorites.style.order = elWidth > (favoriteAndTypeBox.offsetWidth - 16) ? '1' : '0'
            }
        }
    },

    checkSearchedText(text) {
        if (!text) {
            return false
        }

        const arrNamesOpt4 = [
            'вконтакте', 'vkontakte', 'drjynfrnt', 'млщтефсеу', 'vcontakte',
            'vkontacte', 'ok.ru', 'mail', 'youla', 'icq', 'delivery', 'odnoklassniki',
            'одноклассники', 'ок', 'майл.ру', 'юла', 'аська', 'деливери', 'classmates', 'mail group',
        ]
        const searchedText = text.toLowerCase()
        if (arrNamesOpt4.includes(searchedText)) {
            return true
        }

        let searched = false
        arrNamesOpt4.forEach(function(item) {
            if (item.indexOf(searchedText) > -1 || searchedText.indexOf(item) > -1) {
                searched = true
            }
        })
        return searched
    },
}
